export function parseAnyDef() {
    return {};
}
